(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sjcl"), require("aws-sdk"), require("jsbn"));
	else if(typeof define === 'function' && define.amd)
		define(["sjcl", "aws-sdk", "jsbn"], factory);
	else if(typeof exports === 'object')
		exports["AmazonCognitoIdentity"] = factory(require("sjcl"), require("aws-sdk"), require("jsbn"));
	else
		root["AmazonCognitoIdentity"] = factory(root["sjcl"], root["AWSCognito"], root["window"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/